import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LeasingCalculator from './components/LeasingCalculator';
import SeoHead from '../../components/feature/SeoHead';

export default function AcheterPage() {
  const navigate = useNavigate();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.louatiautocenter.ch';

  return (
    <div className="min-h-screen bg-black">
      <SeoHead
        title="Acheter un Véhicule & Calculateur Leasing | Louati AUTOCENTER Payerne"
        description="Achetez votre prochain véhicule chez Louati AUTOCENTER à Payerne. Calculez vos mensualités de leasing en ligne, financement disponible. Découvrez notre stock de voitures d'occasion."
        keywords="acheter voiture Payerne, leasing auto Suisse, financement véhicule Payerne, calculateur leasing"
        canonical={`${siteUrl}/acheter`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Acheter un Véhicule & Calculateur Leasing | Louati AUTOCENTER Payerne",
          "description": "Achetez votre prochain véhicule chez Louati AUTOCENTER à Payerne. Calculez vos mensualités de leasing en ligne.",
          "url": `${siteUrl}/acheter`,
          "inLanguage": "fr-CH",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Accueil", "item": `${siteUrl}/` },
              { "@type": "ListItem", "position": 2, "name": "Acheter un véhicule", "item": `${siteUrl}/acheter` }
            ]
          }
        }}
      />
      <Navbar />

      {/* Hero Section */}
      <section className="relative bg-black text-white py-24 border-b border-gray-800">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 via-transparent to-blue-600/5"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-white via-blue-100 to-white bg-clip-text text-transparent">
              Acheter un Véhicule
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Calculez votre financement en leasing et découvrez nos véhicules disponibles
            </p>
          </div>
        </div>
      </section>

      {/* Calculator Section */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-white mb-4">
                Calculateur de Leasing
              </h2>
              <p className="text-lg text-gray-400">
                Estimez vos mensualités de leasing pour votre futur véhicule
              </p>
            </div>

            <LeasingCalculator />

            <div className="mt-12 text-center">
              <div className="bg-gradient-to-br from-blue-600/10 to-blue-600/5 rounded-xl p-8 border border-blue-600/20 backdrop-blur-sm">
                <i className="ri-car-line text-4xl text-blue-500 mb-4"></i>
                <h3 className="text-xl font-bold text-white mb-3">
                  Découvrez nos véhicules en vente
                </h3>
                <p className="text-gray-300 mb-6">
                  Consultez notre stock de véhicules disponibles et calculez directement votre leasing
                </p>
                <div className="flex flex-wrap gap-4 justify-center">
                  <a
                    href="/vehicules"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-car-line"></i>
                    Voir les véhicules
                  </a>
                  <a
                    href="tel:+41796840588"
                    className="inline-flex items-center gap-2 px-6 py-3 border-2 border-blue-600 text-blue-400 rounded-lg hover:bg-blue-600/10 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line"></i>
                    Nous appeler
                  </a>
                </div>
              </div>
            </div>

            {/* Bouton Retour en bas */}
            <div className="mt-12 text-center">
              <button
                onClick={() => navigate(-1)}
                className="px-6 py-3 border-2 border-blue-600 text-blue-400 rounded-lg font-semibold hover:bg-blue-600/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                Retour
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
